import React from 'react'
import styled, { css } from 'styled-components'
import { getAbsoluteLink } from '../../../helpers/utils'
import SquareLink from './SquareLink'

const v4Title = css`
    --h3: var(--base);
    h3 {
        text-transform: none;
        letter-spacing: 0.5px;
        line-height: 24px;
    }
`
const v4Category = css`
    margin-right: 0;
`

const StyledCategory = styled.ul`
  text-transform: capitalize;
  padding: 0;
  margin-right: 90px;
  list-style: none;
  li {
    font-weight: 400;
    font-size: 13px;
    letter-spacing: 0.25px;
    line-height: 22px;
    padding: 0 0 10px 0;
    cursor: pointer;
    a {
      display: inline-block;
    }
  }

  a:focus,
  a:hover {
    color: unset;
  }
  @media (max-width: 991px) {
    flex: 1 1 0;
    li + li {
      padding: 0px;
      margin-top: 15px;
    }
  }
  ${props => props.version === 'v4' && v4Category}
`
const CategoryTitle = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;

  h3 {
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 0.25px;
    line-height: 20px;
    padding: 0;
    margin: 0;
    margin-bottom: 0;
    font-weight: 700;
  }

  @media (max-width: 991px) {
    flex: 1 1 0;
  }
  ${props => props.version === 'v4' && v4Title}
`
const Category = ({ data, list, containsShop, version }) => {
  if (!containsShop) {
    return (
      <SquareLink
        key={data.title}
        title={data.title}
        link={getAbsoluteLink(data.url, version)}
        url={getAbsoluteLink(data.iconPath, version)}
        version={version}
      />
    )
  }
  return (
    <React.Fragment>
      <CategoryTitle version={version}>
        <h3>{data.title}</h3>
      </CategoryTitle>
      <StyledCategory version={version}>
        {list.map(child => {
          return (
            <li key={child.title}>
              <a href={getAbsoluteLink(child.url, version)}>{child.title}</a>
            </li>
          )
        })}
      </StyledCategory>
    </React.Fragment>
  )
}

export default Category



// WEBPACK FOOTER //
// ./src/components/Navbar/components/Category.js